import Vue from 'vue'
import verge from 'verge'
import store from './store/'

/* Styles */
import '@/styles/app.scss'
import '@/styles/print.scss'

/* Utils */
import '@/utils/polyfills'
import '@/utils/filter'
import '@/utils/directives'
import '@/utils/modernizr-custom'
import '@/utils/correctExtensions'
import { AppDeviceEnquire } from '@/utils/mixin'
// import { showNotyfications } from '@/utils/notifications'

/* Components */
import '@/components'

/* Views */
import '@/views'

const requireComponent = require.context('./components', true, /Z[\w-]+\/index\.js$/)

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)
    let componentName = fileName.split('/')[1]

    for (let key in componentConfig) {
        if (componentConfig.hasOwnProperty(key)) {
            if (key !== 'default') componentName = key
            Vue.component(componentName, componentConfig[key])
        }
    }
})

Vue.component('vue-raw', {
    props: ['raw'],
    render (h) {
        const div = document.createElement('div')
        div.innerHTML = this.raw
        return h(Vue.compile(div.outerHTML.replace(/\s{2,}/g, '')))
    }
})

if (process.env.NODE_ENV !== 'production') {
//     window.onerror = function (msg, url, lineNo, columnNo, error) {
//         showNotyfications(`${msg}<br>${url}#${lineNo}`, {
//             type: 'error'
//         })
//     }

//     Vue.config.errorHandler = function (err, vm, info) {
//         console.error(`Error: ${err.toString()}\nInfo: ${info}\nVm component: ${vm.$options._componentTag}`)
//         showNotyfications(`Error: ${err.toString()}<br>Info: ${info}<br>Vm component: ${vm.$options._componentTag}`, {
//             type: 'error'
//         })
//     }

//     Vue.config.warnHandler = function (msg, vm, trace) {
//         console.warn(`Warn: ${msg.toString()}\nInfo: ${trace}\nVm component: ${vm.$options._componentTag}`)
//         showNotyfications(`Warn: ${msg.toString()}<br>Info: ${trace}<br>Vm component: ${vm.$options._componentTag}`, {
//             type: 'alert'
//         })
//     }

    Vue.config.productionTip = false
}

Object.defineProperty(Vue.prototype, '$bus', {
    get () {
        return this.$root.bus
    }
})

Vue.config.productionTip = false

const vm = new Vue({
    store,
    el: '#app',
    mixins: [AppDeviceEnquire],
    data: {
        viewportW: 0,
        loaded: false,
        app: window.App,
        bus: new Vue({}),
        lang: window.App.page.lang
    },
    mounted () {
        this.loaded = true
        this.viewportW = verge.viewportW()

        metrika()
    },
    computed: {
        appClass () {
            return {
                'loaded': this.loaded
            }
        }
    }
})

window.vm = vm
